import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../hooks/hooks";
import useDarkMode from "../../../hooks/useDarkMode";
import storePersist from "../../../redux/storePersist";
import { razorpay } from "../../../redux/razporpay/action";
import { selectsubscriptionsCreatedItem } from "../../../redux/subscriptions/selector";
import { selectCreatedItem, selectUpdatedItem as selectInitiateRazorpayDetails} from "../../../redux/razporpay/selector";
import { subscriptions } from "../../../redux/subscriptions/action";
import { selectListItems } from "../../../redux/library/selector";
import { business } from "../../../redux/businesses/action";
import { selectBusinessesCreatedItem } from "../../../redux/businesses/selector";

interface FormValues {
  FirstName: string;
  LastName: string;
  Email: string;
  PhoneNumber: string;
  Description: string;
  OwnerType: string;
  OwnerId: number;
  BusinessName: string;
BusinessTypeId: number
IndustryTypeId:number;
  Address1: string;
  Address2: string,
  City: string;
  CountryId: string;
  StateProvinceId: string;
  ZipPostalCode: string;
  Password: string;
  Salutation:string;
}

interface SubscriptionFormProps {
  item: any; // Define a more specific type if possible
}

declare let Razorpay: any;

export const SubscriptionForm: React.FC<SubscriptionFormProps> = ({ item }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const libraryData = useSelector(selectListItems)
  const { register, handleSubmit, clearErrors, formState: { errors }, setValue,trigger  } = useForm<FormValues>();
  const [baseURL, setBaseUrl] = useState<string>('');
  const [colorTheme, setTheme] = useDarkMode();
  const [darkSide, setDarkSide] = useState<boolean>(colorTheme === "light");
  const commerceSubscriptionsCreateItems = useSelector(selectsubscriptionsCreatedItem);
  const businessCreateItems = useSelector(selectBusinessesCreatedItem);
  const razorPayCreateItems = useSelector(selectCreatedItem);
  const initiateRazorpay = useSelector(selectInitiateRazorpayDetails);
  const [subscriptionData, setSubscriptionData] = useState<FormValues | null>(null);
  const [currentStep, setCurrentStep] = useState(1); 
  const [countries, setCountries] = useState<any[]>([]); 
  const [states, setStates] = useState<any[]>([]);
  const [filteredStates, setFilteredStates] = useState<any[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>('');
  const [showPassword, setShowPassword] = useState(false);
  const [isInitiateRazorpayTriggered, setIsInitiateRazorpayTriggered] = useState(false);

	const handleClickShowPassword = () => {
	  setShowPassword(!showPassword);
	};
  useEffect(() => {
    const fetchData = async () => {
      const countries = storePersist?.get('countries')?.current?.items || [];
      const states = storePersist?.get('states')?.current?.items || [];
      setCountries(countries);
      setStates(states);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      const filtered = states.filter(state => state.CountryId == selectedCountry);
      setFilteredStates(filtered);
    } else {
      setFilteredStates(states);
    }
  }, [selectedCountry, states]);

  const handleNextStep = async () => {
    // Trigger validation for all fields in the current step
    const isStepValid = await trigger();
  
    if (isStepValid) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevStep = () => {
    setCurrentStep(currentStep - 1);
  };
  useEffect(() => {
    setBaseUrl(window.location.origin);
    clearErrors();
  }, [clearErrors]);

  useEffect(() => {
    if (commerceSubscriptionsCreateItems?.isSuccess && subscriptionData) {
      dispatch(business.resetAction({actionType:'create'}))
      dispatch(business.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/platform-management/business`,entity:'business',jsonData:{
            
        Records: [
          {
            
           "Context": {},
           "Message": {
            "DBaaSProgramPolicyId": item?.Id,
             "BusinessName": subscriptionData?.BusinessName,
             "BusinessTypeId": subscriptionData?.BusinessTypeId,
             "IndustryTypeId": subscriptionData?.IndustryTypeId,
             "CurrencyCode": "INR",
             "Email": subscriptionData?.Email,
             "CallingCode": "+91",
             "PhoneNumber": subscriptionData?.PhoneNumber,
             "Password": subscriptionData?.Password,
             "Salutation":subscriptionData?.Salutation,
             "FirstName": subscriptionData?.FirstName,
             "LastName": subscriptionData?.LastName,
             "Address1":subscriptionData?.Address1,
             "Address2":subscriptionData?.Address2,
             "City": subscriptionData?.City,
             "CountryId":subscriptionData?.CountryId,
             "StateProvinceId":subscriptionData?.StateProvinceId,
             "ZipPostalCode": subscriptionData?.ZipPostalCode,
             "IsNewsLetterOpted": "true",
             "IsTermsAccepted": "true"
           }
        
         
        }
          
        ]
     
    }}))
    
    }
  }, [commerceSubscriptionsCreateItems]);

  useEffect(() => {
    if (businessCreateItems?.isSuccess) {
      dispatch(razorpay.resetAction({actionType:'createRazorpay'}))
      dispatch(razorpay.createRazorpay({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/orders/initiate-online-order-payment-rp`,
        entity: 'razorpayInitiate',
        jsonData: {
          Records: [
            {
              OwnerType: 'DBaaSSubscription',
              OrderId: commerceSubscriptionsCreateItems?.result[0],
            }
          ]
        }
      })).then(() => {
        setIsInitiateRazorpayTriggered(true);
      });
      dispatch(subscriptions.resetAction({actionType:'create'}))
      dispatch(business.resetAction({actionType:'create'}))
    }
  }, [businessCreateItems]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '/checkout.js';
    script.async = true;
    document.body.appendChild(script);

    if (isInitiateRazorpayTriggered) {
      initiateRazorPayPayment();
    }
  }, [isInitiateRazorpayTriggered]);

  const initiateRazorPayPayment = () => {
    const accessTokenMetadata = storePersist?.get("accessTokenMetadata")?.current;
    const options = {
      key: initiateRazorpay?.result[0]?.PaymentGatewayKey,
      name: accessTokenMetadata?.TokenMetadata?.CompanyName,
      currency: "INR",
      image: 'https://114digiistorage217.blob.core.windows.net/organization/organizationunit/quco-fav.png',
      description: initiateRazorpay?.result[0]?.Description,
      payment: {
        capture: 'automatic',
        capture_options: {
          automatic_expiry_period: 12,
          manual_expiry_period: 7200,
          refund_speed: 'optimum',
        },
      },
      prefill: {
        email: subscriptionData?.Email,
        contact: subscriptionData?.PhoneNumber,
        name: subscriptionData?.FirstName,
      },
      handler: (data: any) => {
        if (data?.razorpay_payment_id) {
          dispatch(razorpay.completeRazorpay({
            url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dom/orders/complete-online-order-payment-rp`,
            entity: 'razorpaycomplete',
            jsonData: {
              Records: [
                {
                  RazorPayOrderId: data?.razorpay_order_id,
                  RazorPaySignature: data?.razorpay_signature,
                  RazorPayPaymentId: data?.razorpay_payment_id,
                  OwnerType: 'DBaaSSubscription',
                },
              ],
            }
          })).then(() => {
            dispatch(razorpay.resetAction({actionType:'createRazorpay'}))
            setIsInitiateRazorpayTriggered(false)
            navigate(`/`);
            toast.success('Program Purchased Successfully');
          });
        }
      },
      theme: {
        color: '#F37254',
      },
      order_id: initiateRazorpay?.result[0]?.PaymentGatewayOrderReferanceId,
    };
    const rzp1 = new Razorpay(options);
    rzp1.open();
  };

  const onFinish: SubmitHandler<FormValues> = async (data) => {
    dispatch(subscriptions.resetAction({actionType:'create'}))
    setSubscriptionData(data);
    dispatch(subscriptions.create({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions`,
      entity: 'subscriptions',
      jsonData: {
        Records: [
          {
            "Email" : data?.Email,
              "PhoneNumber" : data?.PhoneNumber,
              "Name": data?.FirstName,
              "Description": data?.Description,
              "OwnerType": "DBaasProgram",
              "OwnerId": item?.Id,
              "Amount": item?.DBaaSProgram[0]?.Price,
              "Validity": item?.DBaaSProgram[0]?.ProgramDuration,
              "BusinessName": data?.BusinessName,
          }
        ]
      }
    }))
  };

  const toggleDarkMode = (checked: boolean) => {
    setTheme(colorTheme);
    setDarkSide(checked);
  };

  return (
    <form className="max-w-md mx-auto p-4 bg-white shadow-lg rounded-lg mt-12" onSubmit={handleSubmit(onFinish)}>
    <div className="text-center mb-6">
      <h1 className="text-xl font-bold text-qblack">Subscribe Now</h1>
      <span className="block mt-6">
        <svg
          width="200"
          height="20"
          viewBox="0 0 200 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 18.8027C17.6508 10.3626 63.9476 -1.17089 113.509 8.8802C166.729 19.3062 341.329 33.704 353 1"
            stroke="#FFBB38"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </span>
    </div>
  
    {currentStep === 1 && (
      <div className="flex flex-col items-center">
        <p className="text-lg font-semibold mb-4">Basic Info</p>
        <div className="space-y-4 w-full max-w-md">
        <div>
            <label className="block text-sm font-medium text-qgray mb-1">Salutation*</label>
            <select
              {...register('Salutation', { required: "Salutation is required" })}
              className="w-full border border-qgray-border rounded-md p-2 text-sm"
            >
              <option value="">Choose Salutation</option>
              {libraryData?.result?.Salutation?.map((salutation: any) => (
                <option key={salutation.Text} value={salutation.Text}>
                  {salutation.Text}
                </option>
              ))}
            </select>
            {errors.Salutation && <p className="text-red-500 text-xs mt-1">{errors.Salutation.message}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-qgray mb-1">First Name*</label>
            <input
              placeholder="Your Name"
              {...register('FirstName', {
                required: "FirstName is required",
                minLength: { value: 3, message: "Minimum length is 1" },
                maxLength: { value: 100, message: "Maximum length is 100" },
              })}
              type="text"
              className="w-full border border-qgray-border rounded-md p-2 text-sm"
            />
            {errors.FirstName && <p className="text-red-500 text-xs mt-1">{errors.FirstName.message}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-qgray mb-1">Last Name*</label>
            <input
              placeholder="Your Name"
              {...register('LastName', {
                required: "LastName is required",
                minLength: { value: 1, message: "Minimum length is 3" },
                maxLength: { value: 100, message: "Maximum length is 100" },
              })}
              type="text"
              className="w-full border border-qgray-border rounded-md p-2 text-sm"
            />
            {errors.LastName && <p className="text-red-500 text-xs mt-1">{errors.LastName.message}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-qgray mb-1">Phone Number*</label>
            <input
              placeholder="Your Phone Number"
              {...register('PhoneNumber', {
                required: "Phone number is required",
                maxLength: { value: 15, message: "Maximum length is 15" },
                minLength: { value: 10, message: "Minimum length is 10" },
                pattern: { value: /^[0-9+-]+$/, message: "Invalid phone number" },
              })}
              type="text"
              className="w-full border border-qgray-border rounded-md p-2 text-sm"
            />
            {errors.PhoneNumber && <p className="text-red-500 text-xs mt-1">{errors.PhoneNumber.message}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-qgray mb-1">Email Address*</label>
            <input
              placeholder="Your email address"
              {...register('Email', {
                required: "Email is required",
                pattern: {
                  value: /^[^@]+@[^@]+\.[^@]+$/,
                  message: "Invalid email address",
                },
              })}
              type="text"
              className="w-full border border-qgray-border rounded-md p-2 text-sm"
            />
            {errors.Email && <p className="text-red-500 text-xs mt-1">{errors.Email.message}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-qgray mb-1">Password*</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                {...register('Password', { required: true, maxLength: 15 })}
                className="border-0 px-3 py-3 text-indigo-600 rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Password"
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 p-2"
                onClick={handleClickShowPassword}
              >
                {showPassword ? (
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                  </svg>
                )}
              </button>
            </div>
          </div>
          <div>
         <label className="block text-sm font-medium text-qgray mb-1">Message*</label>
         <textarea
           placeholder="Type your message here"
           {...register('Description', { required: "Description is required", minLength: { value: 3, message: "Minimum length is 3" } })}
           className="w-full border border-qgray-border rounded-md p-2 text-sm"
         ></textarea>
         {errors.Description && <p className="text-red-500 text-xs mt-1">{errors.Description.message}</p>}
       </div>
        </div>
      </div>
    )}
  
    {/* Step 2: Business Info Details */}
    {currentStep === 2 && (
      <div className="flex flex-col items-center space-y-4">
        <p className="text-lg font-semibold mb-4">Business Info</p>
        <div className="space-y-4 w-full max-w-md">
          <div>
            <label className="block text-sm font-medium text-qgray mb-1">Business Name*</label>
            <input
              placeholder="Your Business Name"
              {...register('BusinessName', {
                required: "BusinessName is required",
                minLength: { value: 3, message: "Minimum length is 3" },
                maxLength: { value: 100, message: "Maximum length is 100" },
              })}
              type="text"
              className="w-full border border-qgray-border rounded-md p-2 text-sm"
            />
            {errors.BusinessName && <p className="text-red-500 text-xs mt-1">{errors.BusinessName.message}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-qgray mb-1">Business Type*</label>
            <select
              {...register('BusinessTypeId', { required: "Business Type is required" })}
              className="w-full border border-qgray-border rounded-md p-2 text-sm"
            >
              <option value="">Choose Business Type</option>
              {libraryData?.result?.BusinessType?.map((businessType: any) => (
                <option key={businessType.Value} value={businessType.Value}>
                  {businessType.Description}
                </option>
              ))}
            </select>
            {errors.BusinessTypeId && <p className="text-red-500 text-xs mt-1">{errors.BusinessTypeId.message}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-qgray mb-1">Industry Type*</label>
            <select
              {...register('IndustryTypeId', { required: "Industry Type is required" })}
              className="w-full border border-qgray-border rounded-md p-2 text-sm"
            >
              <option value="">Choose Industry Type</option>
              {libraryData?.result?.IndustryType?.map((industryType: any) => (
                <option key={industryType.Value} value={industryType.Value}>
                  {industryType.Text}
                </option>
              ))}
            </select>
            {errors.IndustryTypeId && <p className="text-red-500 text-xs mt-1">{errors.IndustryTypeId.message}</p>}
          </div>
        </div>
      </div>
    )}
  
    {/* Step 3: Address Info */}
    {currentStep === 3 && (
      <div className="flex flex-col items-center space-y-4">
        <p className="text-lg font-semibold mb-4">Address Details</p>
        <div className="space-y-4 w-full max-w-md">
          <div>
            <label className="block text-sm font-medium text-qgray mb-1">Address 1*</label>
        <input
          placeholder="Your Address 1"
          {...register('Address1', {
            required: "Address 1 is required",
            minLength: { value: 3, message: "Minimum length is 3" },
            maxLength: { value: 100, message: "Maximum length is 100" }
          })}
          type="text"
          className="w-full border border-qgray-border rounded-md p-2 text-sm"
        />
        {errors.Address1 && <p className="text-red-500 text-xs mt-1">{errors.Address1.message}</p>}
      </div>
      <div>
        <label className="block text-sm font-medium text-qgray mb-1">Address 2*</label>
        <input
          placeholder="Your Address 2"
          {...register('Address2', {
            required: "Address2 is required",
            minLength: { value: 3, message: "Minimum length is 3" },
            maxLength: { value: 100, message: "Maximum length is 100" }
          })}
          type="text"
          className="w-full border border-qgray-border rounded-md p-2 text-sm"
        />
        {errors.Address2 && <p className="text-red-500 text-xs mt-1">{errors.Address2.message}</p>}
      </div>
      <div>
        <label className="block text-sm font-medium text-qgray mb-1">City*</label>
        <input
          placeholder="Your City"
          {...register('City', {
            required: "City is required",
            minLength: { value: 3, message: "Minimum length is 3" },
            maxLength: { value: 100, message: "Maximum length is 100" }
          })}
          type="text"
          className="w-full border border-qgray-border rounded-md p-2 text-sm"
        />
        {errors.City && <p className="text-red-500 text-xs mt-1">{errors.City.message}</p>}
      </div>
      <div>
        <label className="block text-sm font-medium text-qgray mb-1">Country Name*</label>
        <select
          {...register('CountryId', { required: "Country is required" })}
          onChange={(e) => {
            const countryId = e.target.value;
            setSelectedCountry(countryId);
            setValue('CountryId', countryId); // Update form value
          }}
          className="w-full border border-qgray-border rounded-md p-2 text-sm"
        >
          <option value="">Choose country</option>
          {countries.map((country: any) => (
            <option key={country.Id} value={country.Id}>{country.Name}</option>
          ))}
        </select>
        {errors.CountryId && <p className="text-red-500 text-xs mt-1">{errors.CountryId.message}</p>}
      </div>
      <div>
        <label className="block text-sm font-medium text-qgray mb-1">State Name*</label>
        <select
          {...register('StateProvinceId', { required: "State is required" })}
          className="w-full border border-qgray-border rounded-md p-2 text-sm"
        >
          <option value="">Choose State</option>
          {filteredStates.map((state: any) => (
            <option key={state.Id} value={state.Id}>{state.Name}</option>
          ))}
        </select>
        {errors.StateProvinceId && <p className="text-red-500 text-xs mt-1">{errors.StateProvinceId.message}</p>}
      </div>
      <div>
         <label className="block text-sm font-medium text-qgray mb-1">Zip Code*</label>
         <input
           placeholder="Zip Postal Code"
           {...register('ZipPostalCode', {
             required: "ZipPostalCode is required",
             pattern: { value: /^[0-9+-]+$/, message: "Invalid ZipPostalCode" }
           })}
           type="text"
           className="w-full border border-qgray-border rounded-md p-2 text-sm"
         />
         {errors.ZipPostalCode && <p className="text-red-500 text-xs mt-1">{errors.ZipPostalCode.message}</p>}
       </div>
        </div>
      </div>
    )}
  
  <div className="flex justify-end mt-6">
        {currentStep > 1 && (
          <button
            type="button"
            onClick={handlePrevStep}
            className="bg-blue-500 text-white text-sm font-semibold py-2 px-4 rounded-md hover:bg-blue-600 mr-16"
          >
            Previous
          </button>
        )}

        {currentStep < 3 && (
          <button
            type="button"
            onClick={handleNextStep}
            className="bg-blue-500 text-white text-sm font-semibold py-2 px-4 rounded-md hover:bg-blue-600 justify-end"
          >
            Next
          </button>
        )}

        {currentStep === 3 && (
          <button
            type="submit"
            // onClick={handleSubmit(handleSubscribe)} // Handle subscription on click
            className="bg-green-500 text-white text-sm font-semibold py-2 px-4 rounded-md hover:bg-green-600"
          >
            Subscribe
          </button>
        )}
      </div>
  </form>
  )}